<template>
  <v-card v-if="presentation"
          class="mb-4">
    <div class="d-flex"
         style="width: 100%;">
      <presentation-thumbnail :presentation="presentation">
      </presentation-thumbnail>

      <div class="d-flex flex-column flex-grow-1">
        <v-card-title v-if="matchName"
                      v-html="matchName"
                      class="Search_Result__Highlight py-1 px-2">
        </v-card-title>
        <v-card-title v-else>
          {{ hit.name }}
        </v-card-title>

        <div v-if="presentation.is_internal_use_only"
             class="font-size-12 font-italic px-2">
          FOR INTERNAL USE ONLY
        </div>

        <div v-if="matchContent"
             class="Search_Result__Matches fill-height">
          <h4>
            Highlights
          </h4>
          <div v-if="showHighlight && matchContent"
               v-html="matchContent"
               class="Search_Result__Highlight">
          </div>
          <div v-else
               class="Search_Result__Highlight">
            <div style="font-style: italic;">Highlights are not shown for this type of file.</div>
          </div>
        </div>
      </div>
    </div>
    <v-card-actions>
      <presentation-card-actions :presentation="presentation"
                                 style="width: 230px;">
      </presentation-card-actions>
    </v-card-actions>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import {find} from 'lodash';
import PresentationCardActions from '../../content/components/PresentationCardActions';
import PresentationThumbnail from '../../content/components/PresentationThumbnail';

export default {
  components: {PresentationThumbnail, PresentationCardActions},
  props: {
    hit: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('content', [
      'presentations',
    ]),
    formatted() {
      return this.hit._formatted;
    },
    matchName() {
      if (this.formatted) {
        return this.formatted.name;
      }
      return null;
    },
    matchContent() {
      if (this.formatted) {
        return this.formatted.content;
      }
      return null;
    },
    showHighlight() { // MLD-4069
      if (this.presentation && this.presentation.type_html === false) {
        return true;
      }
      return false;
    },
    presentation() {
      return find(this.presentations, p => p.id === this.hit.id);
    },
    thumbnail() {
      if (this.presentation) {
        return this.presentation.thumbnail;
      }
      return null;
    }
  }
}
</script>
